import { TextField } from "@mui/material";
import React from "react";

export default function CustomInputCell({
  name,
  row,
  onChange,
  type = "string",
  placeholder,
  fullWidth = true,
  sx,
}) {
  function capitalize(word) {
    if (!word) return "";
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  return (
    <TextField
      name={name}
      onChange={(e) => onChange(e, row.original)}
      value={row.original?.[name] || ""}
      size="small"
      variant="standard"
      placeholder={placeholder ? placeholder : "Add " + capitalize(name)}
      type={type}
      autoComplete="off"
      fullWidth={fullWidth}
      sx={{ ...sx }}
    />
  );
}
